// extracted by mini-css-extract-plugin
module.exports = {"root":"_0f20b46","content":"_b087181","image":"_e5b9733","text":"_44f6e32","heading":"_7dedc98","subheading":"_2ee9b52","description":"_6ac70c9","cta":"_9082193"};